module.exports = __webpack_public_path__ + "img/Stab_S1.06e1c6c9.svg";